const $$splitComponentImporter = () => import('/app/apps/web/src/routes/login/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
export const Route = createFileRoute("/login/")({
  validateSearch: z.object({
    type: z.literal("signeringsportal").optional(),
    url: z.string().optional(),
    error: z.string().optional() // Added by the API login handler
  }),
  head: () => ({
    meta: [{
      title: "Logg inn | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});